import { render } from "./formularioAsegurados.vue?vue&type=template&id=17b5b6de"
import script from "./formularioAsegurados.vue?vue&type=script&lang=js"
export * from "./formularioAsegurados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__